// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3sTL2eDUzdYkTr3jb2ayKC{display:flex}", "",{"version":3,"sources":["webpack://./resources/js/components/AppHeader/BottomHeader/ProfileButton/styles.module.scss"],"names":[],"mappings":"AAAA,yBACI,YACJ","sourcesContent":[".account_dropdown {\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"account_dropdown": "_3sTL2eDUzdYkTr3jb2ayKC"
};
export default ___CSS_LOADER_EXPORT___;
